<div class="singel-event">
    <span>Batch starts on : <i class="fa fa-calendar"></i> {{ddmmyyyy | date:'dd-MM-yyy'}} </span>
    <a routerLink="/Courses">
        <h4> {{title}} </h4>
    </a>
    <!-- <span><i class="fa fa-clock-o"></i> {{startTime}} - {{endTime}}</span>
    <span><i class="fa fa-map-marker"></i> {{location}} </span> -->
</div>